import { useEffect, useRef } from 'react'
import { useLang } from '../utils/hooks'
import { langCGU } from '../assets/langCGU'
import Footer from '../components/Footer'

const CGU = () => {
  const firstDiv = useRef(null)
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langCGU.fr : langCGU.eng

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  return (
    <div>
      <section className="section" ref={firstDiv}>
        <div className="notification is-info is-light is-size-5 ml-6 mr-6">
          <h1 className="subtitle is-5 has-text-right">{choosenLang.title}</h1>
          {choosenLang.articles.map((article) => {
            let item
            switch (article.type) {
              case 'h1':
                item = <h1 className={article.cl}>{article.text}</h1>
                break
              case 'h2':
                item = <p className={article.cl}>{article.text}</p>
                break
              default:
                item = <p className={article.cl}>{article.text}</p>
                break
            }
            return item
          })}
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default CGU
